export default "__VITE_ASSET__Cq8pioPU__"